// App.jsx
import React, {useRef} from 'react';
import { CustomToolbar } from './CustomToolbar';
import { LoadImageFromUrl } from './LoadImageFromUrl'
import { ExportButton } from './buttonExport'
import { Tldraw, useEditor } from 'tldraw';
import 'tldraw/tldraw.css'

export default function App() {

	return (
		<div style={{ position: 'relative', width: '100vw', height: '85vh' }}>
			<Tldraw
				components={{
					Toolbar: CustomToolbar,
				}}
			>
				<LoadImageFromUrl />	
				<ExportButton />
			</Tldraw>
			
		</div>
		
	);
}
